const attachmentLeaderboard = {
  id: '544f947c-390b-4200-b599-d60b3a5bd46e',
  contentType: 'application/vnd.microsoft.card.adaptive',
  name: null,
  thumbnailUrl: null,
  contentUrl: null,
  content: JSON.stringify({
    type: 'AdaptiveCard',
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    version: '1.4',
    body: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 2,
            items: [
              {
                type: 'TextBlock',
                text: 'Leaderboard',
                wrap: true,
                fontType: 'Default',
                size: 'Medium',
                weight: 'Bolder',
                separator: true,
                spacing: 'Medium'
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🥇 1st',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_FIRST_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_FIRST_POINTS}}',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🥈 2nd',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_SECOND_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_SECOND_POINTS}}',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🥉 3rd',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_THIRD_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_THIRD_POINTS}}',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '...',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: ' ',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: ' ',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_POSITION}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{FIRST_NAME}} {{LAST_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_POINTS}} points',
                        wrap: true
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    actions: [
      {
        type: 'Action.OpenUrl',
        title: '[[INPUT_GO_TO_PLATFORM_BUTTON_TEXT]]',
        url: '{{PLATFORM_LINK}}'
      }
    ]
  })
};

const attachmentCollectiveGoal = {
  id: '544f947c-390b-4200-b599-d60b3a5bsdas',
  contentType: 'application/vnd.microsoft.card.adaptive',
  name: null,
  thumbnailUrl: null,
  contentUrl: null,
  content: JSON.stringify({
    type: 'AdaptiveCard',
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    version: '1.4',
    body: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 2,
            items: [
              {
                type: 'TextBlock',
                text: '{{COLLECTIVE_GOAL_ICON}} {{COLLECTIVE_GOAL_HEADLINE}}',
                wrap: true,
                fontType: 'Default',
                size: 'Medium',
                weight: 'Bolder'
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '60px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{COLLECTIVE_GOAL_PROGRESS}}',
                        weight: 'Bolder',
                        size: 'ExtraLarge',
                        spacing: 'Large',
                        height: 'stretch',
                        wrap: true,
                        maxLines: 0
                      }
                    ],
                    spacing: 'None'
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{COLLECTIVE_GOAL_FIRST_LINE}}',
                        wrap: true,
                        weight: 'Bolder'
                      },
                      {
                        type: 'TextBlock',
                        text: '{{COLLECTIVE_GOAL_SECOND_LINE}}',
                        wrap: true,
                        spacing: 'None'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 2,
            items: [
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  })
};

export default {
  id: 'teams_gamification_individual',
  title: 'Gamification - Individual',
  type: 'Direct',
  description: 'Message the overall standing of the collective goal and leaderboard to the participants.',
  body: {
    attachments: [ attachmentCollectiveGoal, attachmentLeaderboard ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_PRE_LEADERBOARD_TEXT]]</p>
        <attachment id='${attachmentCollectiveGoal.id}'></attachment>
        <attachment id='${attachmentLeaderboard.id}'></attachment>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  inputs: {
    INPUT_PRE_LEADERBOARD_TEXT: {
      label: 'Text before leaderboard',
      placeholder: 'Hi All ...',
      defaultValue: '<p>Hi All,</p><p>The current standing of the leaderboard and collective goal is the following</p>',
      type: 'HTML'
    },
    INPUT_GO_TO_PLATFORM_BUTTON_TEXT: {
      label: 'Go to platform button text',
      placeholder: 'Go to platform',
      defaultValue: 'Go to platform',
      type: 'STRING'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/gamificationUpdateIndividual.js